import React, { createContext, useContext, useState } from "react";
import Toast from "../components/GlobalComponents/Toast";

type ToastType = "success" | "error" | "info";

interface ToastContextType {
  showToast: (message: string, type: ToastType) => void;
  hideToast: () => void;
}

const ToastContext = createContext<ToastContextType | undefined>(undefined);

export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [type, setType] = useState<ToastType>("info");

  const showToast = (message: string, type: ToastType) => {
    setMessage(message);
    setType(type);
    setIsOpen(true);

    setTimeout(() => {
      setIsOpen(false);
    }, 2000);
  };

  const hideToast = () => {
    setIsOpen(false);
  };

  return (
    <ToastContext.Provider value={{ showToast, hideToast }}>
      {children}
      <Toast isOpen={isOpen} message={message} type={type} onDidDismiss={() => setIsOpen(false)} />
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  return context;
};
